export default "__VITE_ASSET__DNISdYIg__"